<ng-template #dropdownButtonTemplate>
  <div class="additional-filters__dropdown-button">
    <i
      class="additional-filters__icon material-icon material-icon--outlined"
      [class.additional-filters__icon--black]="hasValue"
    >
      tune
    </i>

    {{ 'filters.common.additionalFilters' | i18n }}
  </div>
</ng-template>

<ng-template #dropdownContentTemplate>
  <div class="additional-filters__main">
    <div
      class="additional-filters__row"
      *ngIf="activeAdditionalFilters.get('category')"
    >
      <lib-category-filter
        (update)="onCategoryChange($event)"
      ></lib-category-filter>

      <div class="additional-filters__subcategory">
        <lib-subcategory-filter
          [categoryFilter]="currentCategory"
          (update)="onSubcategoryChange($event)"
        ></lib-subcategory-filter>
      </div>
    </div>

    <div
      class="additional-filters__row"
      *ngIf="activeAdditionalFilters.get('price')"
    >
      <lib-price-filter (update)="onPriceChange($event)"></lib-price-filter>
    </div>

    <div
      class="additional-filters__row"
      *ngIf="activeAdditionalFilters.get('roomCount')"
    >
      <lib-room-count-filter
        (update)="onRoomCountChange($event)"
      ></lib-room-count-filter>
    </div>

    <div
      class="additional-filters__row"
      *ngIf="activeAdditionalFilters.get('livingSpace')"
    >
      <lib-living-space-filter
        (update)="onLivingSpaceChange($event)"
      ></lib-living-space-filter>
    </div>

    <div
      class="additional-filters__row"
      *ngIf="activeAdditionalFilters.get('usageSpace')"
    >
      <lib-usage-space-filter
        (update)="onUsageSpaceChange($event)"
      ></lib-usage-space-filter>
    </div>

    <div
      class="additional-filters__row"
      *ngIf="activeAdditionalFilters.get('propertySpace')"
    >
      <lib-property-space-filter
        (update)="onPropertySpaceChange($event)"
      ></lib-property-space-filter>
    </div>
  </div>
</ng-template>

<ng-template #applyButtonTemplate let-close="close">
  <button class="filter-apply-button" (click)="applyChanges(); close()">
    {{ 'common.apply' | i18n }}
  </button>
</ng-template>

<app-filter-dropdown
  [preferredWidth]="271"
  [maxHeight]="562"
  [dropdownButtonTemplate]="dropdownButtonTemplate"
  [dropdownContentTemplate]="dropdownContentTemplate"
  [applyButtonTemplate]="applyButtonTemplate"
  [hasValue]="hasValue"
  (clear)="reset()"
>
</app-filter-dropdown>
